import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Strings } from "../../constant/Strings";
import * as actions from "../../Redux/Actions";
import { useDispatch } from "react-redux";
import {
  showErrorToastMessage,
  showSuccessToastMessage,
} from "../../component/Toasts/Toasts";
import useLoadingIndicator from "../../component/Loader/Loader";

const UpdateQuestion = (props: any) => {
  const { loadingComponent, showLoadingIndicator, hideLoadingIndicator } =
    useLoadingIndicator();
  const [btnDisable, setBtnDisable] = useState(true);
  const {
    chatBotDetails,
    hideAssignRoles,
    apiCallCompleted,
    GetApiDispatch
  } = props;
  console.log("chatBotDetails", chatBotDetails)
  const [editValues, setEditValues] = useState({
    question: chatBotDetails?.question,
    answer: chatBotDetails?.answer,
    status: chatBotDetails?.status
  })
  const { cancel, submit, editSuccess, error_description_alternative } =
    Strings;
  const dispatch = useDispatch();


  const handleSubmit = () => {
    const userLogin: any = localStorage.getItem("login");
    const loginId = JSON.parse(userLogin).id;

    showLoadingIndicator();

    const payload = {
      _id:chatBotDetails?._id,
    answer:editValues.answer,
    status:editValues.status,
    updatedBy:loginId
    };
    dispatch(
      actions.chatBotUpdateAction(payload, (res: any) => {
        if (res?.error?.error_description) {
          apiCallCompleted(true);
          showErrorToastMessage(res?.error?.error_description);
          hideLoadingIndicator();
          hideAssignRoles();
        } else if (res?.code === 500) {
          apiCallCompleted(true);
          hideLoadingIndicator();
          hideAssignRoles();
          showErrorToastMessage(error_description_alternative);
        } else if (res.code === 200) {
          apiCallCompleted(true);
          showSuccessToastMessage(editSuccess);
          hideLoadingIndicator();
          hideAssignRoles();
          GetApiDispatch();
        }
      })
    );
  };
  return (
    <>
      {loadingComponent()}
      <div className="row g-3">
        <div className="col-md-12">
          <label className="form-label">
            Question
          </label>
          <input
            type="text"
            className="form-control"
            value={editValues?.question}
            disabled={true}
          />
        </div>
        <div className="col-md-12">
          <label className="form-label">
            Answer
          </label>
          <textarea
            style={{ height: "100px" }}
            className="form-control"
            value={editValues?.answer}
            onChange={(e) =>
              setEditValues({ ...editValues, answer: e.target.value })
            }
          />
        </div>

        <div className="col-md-12">
          <label className="form-label">Status</label>
          <select
            className="form-control"
            value={editValues?.status}
            onChange={(e) =>
              setEditValues({ ...editValues, status: e.target.value })
            }
          >
            <option value="">Select Status</option>
            <option value="Pending">Pending</option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
          </select>
        </div>


        <div className="modal-btn-wrapper mt-5 mx-auto">
          <div>
            <button
              className="btn cancel-btn buttonsize"
              onClick={hideAssignRoles}
              title="Cancel Button"
            >
              {cancel}
            </button>
          </div>
          <div>
            <button
              className={
                btnDisable
                  ? "btn add-submit-button buttonsize"
                  : "btn add-submit-button btn-disabled buttonsize"
              }
              title="Submit Button"
              onClick={handleSubmit}
            >
              {submit}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateQuestion;
